<nav class="grid-nav">
    <a href="" class="grid-nav__link pr-1" (click)="gridNavService.layout.next('grid');false;" [ngClass]="{ 'grid-nav__link--active': gridNavService.formation === 'grid' }">
        <mlp-ng-icon name="layout-module-1"></mlp-ng-icon>
    </a>
    <a href="" class="grid-nav__link ml-2" (click)="gridNavService.layout.next('list');false;" [ngClass]="{ 'grid-nav__link--active': gridNavService.formation === 'list' }">
        <mlp-ng-icon name="list-bullets-1"></mlp-ng-icon>
    </a>
</nav>